import { cn } from "@/components/podkit/lib/cn";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="skeleton"
            className={cn("animate-pulse rounded-md dark:animate-skeleton-pulse dark:bg-surface-secondary", className)}
            {...props}
        />
    );
}
export { Skeleton };
